export const getSellerAccess = (user, accountStatus = null) => {
  if (!user) {
    return {
      redirectTo: "/login",
      allowedRoutes: [],
    };
  }

  // ✅ NEW LOGIC: Seller access gated on email + phone verified only.
  // KYC & bank/payout verification is enforced at bid/product submission via popup.
  const isEmailVerified =
    user?.email_verified_at !== null && user?.email_verified_at !== undefined;
  const isPhoneVerified =
    user?.phone_verified_at !== null && user?.phone_verified_at !== undefined;
  const isContactVerified = isEmailVerified && isPhoneVerified;

  if (isContactVerified) {
    // Full seller dashboard access granted
    return {
      allowedRoutes: ["/seller"],
      redirectTo: "/seller/dashboard",
    };
  }

  // Contact not verified → restrict to verification pages only
  return {
    allowedRoutes: ["/seller"],
    redirectTo: "/seller/dashboard",
    // allowedRoutes: ["/seller/verification-list", "/seller/verification-form"],
    // redirectTo: "/seller/verification-list",
  };

  // // OLD LOGIC: kyc_verified + bank/stripe gate (commented out)
  // // KYC + bank/stripe are now enforced at bid submission level via popup.
  // const {
  //   kyc_verified,
  //   certification_verified,
  //   stripe_account_id,
  //   addresses_count,
  //   charges_enabled,
  //   payouts_enabled,
  //   details_submitted,
  //   is_bank_verified,
  // } = user;
  //
  // // Stripe flags can come from user (session) or accountStatus (API response)
  // const isStripeConnected = stripe_account_id &&
  //   (accountStatus ?
  //     (accountStatus.charges_enabled && accountStatus.payouts_enabled && accountStatus.details_submitted) :
  //     (charges_enabled && payouts_enabled && details_submitted)
  //   );
  // const isBankVerified = is_bank_verified === 1;
  //
  // // Default: only KYC page allowed
  // let allowedRoutes = ["/seller/upload-kyc"];
  // let redirectTo = "/seller/upload-kyc";
  //
  // if (kyc_verified === 1) {
  //   allowedRoutes.push("/seller/certificate");
  //   redirectTo = "/seller/certificate";
  // }
  //
  // if (kyc_verified === 1 && certification_verified === 1) {
  //   allowedRoutes.push("/seller/profile");
  //   allowedRoutes.push("/seller/edit-profile");
  //   allowedRoutes.push("/seller/address");
  //   redirectTo = "/seller/profile";
  // }
  //
  // // Dashboard access requires KYC, Certification, Stripe, AND a Business Address
  // if (
  //   kyc_verified === 1 &&
  //   certification_verified === 1 &&
  //   stripe_account_id &&
  //   (addresses_count > 0 || addresses_count === undefined) // fallback for legacy sessions
  // ) {
  //   allowedRoutes = ["/seller"];
  //   redirectTo = "/seller/dashboard";
  // }
  //
  // // NEW CENTRALIZED LOGIC (intermediate step — also commented out)
  // // Access granted if KYC is approved AND (Bank is verified OR Stripe is connected)
  // if (kyc_verified === 1 && (isBankVerified || isStripeConnected)) {
  //   allowedRoutes = ["/seller"];
  //   redirectTo = "/seller/dashboard";
  // }
  //
  // return { redirectTo, allowedRoutes };
};
